import styled from 'styled-components'

export const StyledHomeWrapper = styled.div`
  .access-level-table {
    &__row {
      border: none;
      background-color: ${({theme}) => theme.surface.subtle};
      &:nth-child(2n) {
        background-color: ${({theme}) => theme.surface.background};
      }
    }
    @media screen and (max-width: 992px) {
      &__body {
        display: grid;
        grid-template-columns: 1fr;
        grid-gap: 15px;
      }
      &__row {
        background-color: ${({theme}) => theme.surface.background};
        border: 1px solid ${({theme}) => theme.surface.border};
        border-radius: 5px;
      }
    }
  }
`;


export const StyledHomeWarning = styled.div`
  margin-top: 16px;
  
  p {
    padding-bottom: 8px;
    
    &:first-child {
      font-weight: 600;
    }
  }
`;